import script from "./BookOfTheDayBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookOfTheDayBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BookOfTheDayBlock.vue?vue&type=style&index=0&id=6dcad790&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dcad790"]])

export default __exports__